module.exports = __webpack_public_path__ + "img/menu_ladies_diet.1cc3263a.png";